import React from "react";
import DOMPurify from "dompurify";
import { useCountdownStore } from "../../../../stores/use-countdown-store";
import { useEffect } from "react";
import {
  StyledEditableTextarea,
  StyledTextareaCalculator,
} from "../../../../components/inline-edit/styled";

function EditableText({ isEditable, value, propKey }) {
  const { data, setData } = useCountdownStore((state) => ({
    data: state.data,
    setData: state.setData,
  }));

  const textareaRef = React.useRef();
  const textareaHelperRef = React.useRef();

  useEffect(() => {
    if (!data.id || !isEditable || !propKey) return;

    const resizeObserver = new ResizeObserver((entries) => {
      const entry = entries[0];
      const helperHeight = entry.contentRect.height;
      if (textareaRef?.current) {
        textareaRef.current.style.height = `${helperHeight}px`;
      }
    });
    const element = document.getElementById(
      `${data.id}-countdown-editable-${propKey}`
    );
    if (element) {
      resizeObserver.observe(element);
    }
  }, [data.id, isEditable, value, propKey]);

  return (
    <>
      {isEditable ? (
        <>
          <StyledEditableTextarea
            ref={textareaRef}
            value={value}
            onInput={(e) => {
              setData({ [propKey]: e.target.value });
            }}
            style={{ width: "100%", overflow: "hidden" }}
          />
          <StyledTextareaCalculator
            id={`${data.id}-countdown-editable-${propKey}`}
            ref={textareaHelperRef}
            width="100%"
            dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(value) }}
          />
        </>
      ) : (
        value
      )}
    </>
  );
}

export default EditableText;
